import ApplicationSerializer from './application';

export default class MailerBlockSerializer extends ApplicationSerializer {
  attrs = {
    requiredAttributes: {
      serialize: false,
    },
    deactivatable: {
      serialize: false,
    },
    editable: {
      serialize: false,
    },
    sortable: {
      serialize: false,
    },
  };
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'mailer-block': MailerBlockSerializer;
  }
}
